/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsCycleDeleteResponse } from '../../models/submissions-cycle-delete-response';

export interface DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Params {
  id: string;
  org: string;
}

export function deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete(http: HttpClient, rootUrl: string, params: DeleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycleDeleteResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsCycleDeleteResponse>;
    })
  );
}

deleteSubmissionsCycleApiV2SubmissionsCycleOrgIdDelete.PATH = '/api/v2/submissions-cycle/{org}/{id}';
